import { render } from "./pagckageStarCategoryAdd.vue?vue&type=template&id=7548cda7&scoped=true"
import script from "./pagckageStarCategoryAdd.vue?vue&type=script&lang=js"
export * from "./pagckageStarCategoryAdd.vue?vue&type=script&lang=js"

import "./pagckageStarCategoryAdd.vue?vue&type=style&index=0&id=7548cda7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7548cda7"]])

export default __exports__